import { Modal as ReactOverlaysModal } from 'react-overlays';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from './Button';
import { useCallback } from 'react';

const Modal = ({
  as,
  className,
  icon: Icon,
  title,
  text,
  modalBodyProps,
  cancelButtonProps,
  okButtonProps,
  show,
  onHide,
  onEscapeKeyDown,
  onBackdropClick,
  children,
  ...props
}) => {
  const { t } = useTranslation('common');

  const Component = as || 'div';

  const handleClick = useCallback((event) => {
    if (onBackdropClick && event.target.classList.contains('modal')) {
      onBackdropClick(event);
    }
  }, [onBackdropClick]);

  return (
    <ReactOverlaysModal
      className={classNames(
        'modal',
        Icon && 'modal--with-icon',
        (!!cancelButtonProps ^ !!okButtonProps) && 'modal--single-button',
        className,
      )}
      show={show}
      onHide={onHide}
      onEscapeKeyDown={onEscapeKeyDown}
      onClick={handleClick}
      {...props}
    >
      <Component className="modal__body" {...modalBodyProps}>
        {title && (
          <h4 className="modal__title">
            {Icon && (
              <Icon className="modal__icon" aria-hidden="true" />
            )}
            {title}
          </h4>
        )}
        {text && (
          <p
            className="modal__text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {children}
        {(cancelButtonProps || okButtonProps) && (
          <div className="modal__buttons">
            {cancelButtonProps && (
              <Button
                className="modal__button"
                size="lg"
                variant="primary-ghost"
                {...cancelButtonProps}
              >
                {cancelButtonProps.children || t('common:modal.cancel')}
              </Button>
            )}
            {okButtonProps && (
              <Button
                className="modal__button"
                size="lg"
                variant="primary"
                {...okButtonProps}
              >
                {okButtonProps.children || t('common:modal.ok')}
              </Button>
            )}
          </div>
        )}
      </Component>
    </ReactOverlaysModal>
  );
};

Modal.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
  text: PropTypes.string,
  modalBodyProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  okButtonProps: PropTypes.object,
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onEscapeKeyDown: PropTypes.func,
  onBackdropClick: PropTypes.func,
  children: PropTypes.node,
};

export default Modal;
